module.exports = __webpack_public_path__ + "img/Room5_007.839bf57c.svg";